import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {
	const token = localStorage.getItem('admin_token')

	return token ? <Navigate to={AUTHENTICATED_ENTRY} replace /> : <Outlet />
}

export default PublicRoute
